import { useEffect, useState } from 'react';

export function useMainPosition() {
  const [position, setPosition] = useState({ top: 0, left: 0 });

  useEffect(() => {
    const main = document.querySelector('main');
    if (!main) return;

    const updatePosition = () => {
      const { top, left } = main.getBoundingClientRect();
      setPosition({ top, left });
    };

    updatePosition();

    const observer = new ResizeObserver(updatePosition);
    observer.observe(main);

    window.addEventListener('scroll', updatePosition, true);

    return () => {
      observer.disconnect();
      window.removeEventListener('scroll', updatePosition, true);
    };
  }, []);

  return position;
}
